import { SALES_ITEM_BOOKING_FLOW_TYPE } from 'noddi-types';
import { compareLicensePlates } from 'noddi-util';
import {
  useBookingAddress,
  useBookingCars,
  useBookingCarsInsuranceInfo,
  useBookingSelectedSalesItemsCars
} from './bookingStore';

export const useIsAddressStepValid = () => {
  const selectedAddress = useBookingAddress();
  return !!selectedAddress?.id;
};

export const useIsCarStepValid = () => {
  const selectedCars = useBookingCars();
  return !!selectedCars?.length;
};

export const useIsSalesItemStepValid = () => {
  const selectedCars = useBookingCars();
  const selectedSalesItemsCars = useBookingSelectedSalesItemsCars();

  // All selected cars need to have at least one salesItem
  return selectedCars.every((car) =>
    selectedSalesItemsCars.some((item) => compareLicensePlates(item.licensePlate, car.licensePlate))
  );
};

export const useIsTireHotelPickUpStepValid = () => {
  const selectedSalesItemsCars = useBookingSelectedSalesItemsCars();
  const carsWithWheelPickup = selectedSalesItemsCars.filter((car) => car.isWheelPickupRequired);

  // All cars with pick up required need to have a salesItem of type TIRE_HOTEL_PICKUP
  return carsWithWheelPickup.every((car) =>
    selectedSalesItemsCars.some(
      (selectedCar) =>
        compareLicensePlates(selectedCar.licensePlate, car.licensePlate) &&
        selectedCar.type === SALES_ITEM_BOOKING_FLOW_TYPE.TIRE_HOTEL_PICKUP
    )
  );
};

export const useIsInsuranceStepValid = () => {
  const selectedCars = useBookingCars();
  const insuranceInfo = useBookingCarsInsuranceInfo();

  // Check if all selected cars have valid insurance info
  return selectedCars.every((car) => {
    const carInsuranceInfo = insuranceInfo.find((insurance) =>
      compareLicensePlates(insurance.licensePlate, car.licensePlate)
    );
    // If no insurance info exists for this car, it's invalid
    if (!carInsuranceInfo) {
      return false;
    }

    const { insuranceCompanyName, dateOfDamage, isGlassDamageCovered } = carInsuranceInfo;

    // Explicitly check for false to distinguish between undefined (not set) and false (user indicated no glass coverage)
    if (isGlassDamageCovered === false) {
      return !!dateOfDamage;
    }

    return !!insuranceCompanyName && !!dateOfDamage;
  });
};
